import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {injectIntl} from 'react-intl'

import { themeFontSize, themeFontWeight, Copy, Flex } from '@elparking/components'

import getPrice from './getPrice'
import ParkingPrice from './ParkingPrice'
import {
    ButtonPrice,
    ParkingPriceBlock,
} from './layout'
import { getBookButtonMessage } from './getBookButtonMessage'

const PriceWrapper = styled(Copy)`
    font-size: ${themeFontSize('xxLarge')};
    font-weight: ${themeFontWeight('book')};
    color: inherit;
    padding: 0;
`

const PriceMessageWrapper = styled(Copy)`
    font-size: ${themeFontSize('large')};
    font-weight: ${themeFontWeight('book')};
    color: inherit;
    padding: 0;
`

class ParkingCardButton extends React.PureComponent {
    static propTypes = {
        intl: PropTypes.object,
        parking: PropTypes.shape({
            isActive: PropTypes.bool,
            estimatedBookingPrice: PropTypes.shape({
                usedPeriodToEstimate: PropTypes.any,
            }),
            price: PropTypes.number,
            bookingAvailability: PropTypes.shape({
                availabilityStatus: PropTypes.string,
                price: PropTypes.number,
            }),
            typeString: PropTypes.string,
        }),
        onClick: PropTypes.func,
        buttonComponent: PropTypes.elementType,
    }

    static defaultProps = {
        onClick: () => {},
        buttonComponent: ButtonPrice,
    }

    render () {
        const { parking, onClick, buttonComponent: Button } = this.props
        const price = getPrice(parking)
        const message = getBookButtonMessage(parking)
        const timeUnit = parking.isActive ? null : parking.estimatedBookingPrice && parking.estimatedBookingPrice.usedPeriodToEstimate

        return (
            <Button
              onClick={onClick}
              width='100%'
              height='40px'
              fontSize='small'
            >
                <ParkingPriceBlock>
                    <ParkingPrice
                      price={price}
                      priceWrapper={({children}) => <PriceWrapper as='span'>{children}</PriceWrapper>}
                      currencyWrapper={({children}) => <PriceWrapper as='span'>{children}</PriceWrapper>}
                      priceMessageWrapper={({children}) => <PriceMessageWrapper as='span'>{children}</PriceMessageWrapper>}
                      timeUnit={timeUnit}
                    />
                </ParkingPriceBlock>
                <Flex flex='1 0 auto'>
                    <Copy as='span' padding='0' align='center' color='white' size='xLarge' fontWeight='book' w='100%'>
                        {this.props.intl.formatMessage(message)}
                    </Copy>
                </Flex>
            </Button>
        )
    }
}

export default injectIntl(ParkingCardButton)
